
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/terms-of-service/archive",
      function () {
        return require("private-next-pages/terms-of-service/archive.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/terms-of-service/archive"])
      });
    }
  